import axios from 'axios'

export default {

    validImageTypes: ['png', 'jpg', 'gif'],

    loadWorkFileAsImage(fileName) {
        return new Promise((resolve, reject) => {

            var imageType = fileName.substr(fileName.lastIndexOf(".") + 1);
            if (!this.validImageTypes.includes(imageType))
                reject("type " + imageType + " is not a valid image type")

            if (fullPath.startsWith("data:image/")) resolve(fullPath);

            var fullPath = fileName.startsWith("files") ? '/rest/v4/' + fileName : '/rest/v4/files/' + fileName
            axios.get(fullPath, {
                responseType: 'arraybuffer'
            }).then(response => {
                var src = 'data:image/' + imageType + ';base64,' + Buffer.from(response.data, 'binary').toString('base64')
                resolve(src)
            }).catch(error => reject(error))
        })
    }
}